/** @module ProductSpec/SizeChart/IncrementView */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi",
	"csi/html/Widget",
	"csi/widget/FormGroupContainer",
	"csi/widget/MockSizeChartPropertiesChanging",
	"csi/xml"
], function(declare, _, csi, HtmlWidget, FormGroupContainer, MockSizeChart, xml) {
	/**
	 * This is view widget for Size Chart -> Increment selection view
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> Increment" tooltip "Edit"
	 * ProductSpec.xml
	 * View Id="Increment" xsi:type="Html"
	 * Template="ProductSpec/SizeChart/IncrementView.html"
	 * ControllerClass="ProductSpec/SizeChart/IncrementView"
	 */

	return declare(HtmlWidget, {

		/**@property {boolean} saveDisabled - vutton Save disabled status. True for disabled */
		saveDisabled: true,
		/** @property {string} newIncrement - Increment new selection */
		newIncrement: csi.EMPTY_URL,
		/** @property {string} newProductGroup - Product Group new selection */
		newProductGroup: csi.EMPTY_URL,
		/** @property {boolean} maintainBaseSize - radio group "Maintain Base Size" selection */
		maintainBaseSize: false,
		/** @property {boolean} maintainTolerances - radio group "Maintain Tolerances" selection */
		maintainTolerances: false,
		/** @property {boolean} maintainDimensions - radio group "Maintain Dimensions" selection  */
		maintainDimensions: false,
		/** @property {boolean} maintainIncrements - radio group "Maintain Increments" selection  */
		maintainIncrements: false,

		/** reference to productGroupForm widget */
		productGroupForm: null,

		/**
		 * @override
		 * Add Size Chart Mockup at the bottom of html view
		 */
		_postView: function() {
			this.inherited(arguments);

			_.delay(() => {
				new FormGroupContainer({
					additionalWidget: new MockSizeChart({
						excludeGroups: [],
						onClick: values => {
							this.maintainIncrements = values.maintainIncrements;
							this.maintainTolerances = values.maintainTolerances;
							this.maintainDimensions = values.maintainDimensions;
							this.maintainBaseSize = values.maintainBaseSize;
							this.refreshSaveBtn();
						}
					})
				}).placeAt("productSizeChartWizard");
				this.productGroupForm.refreshRadioGroup();
			});
		},

		/**
		 * @ovrride
		 * Control enabled/disabled status of dialog Save action button
		 */
		canEnableButton: function(button, idAction) {
			return (idAction != "Save") || !this.saveDisabled;
		},

		/**
		 * Control enabled/disabled status of dialog Save button
		 */
		refreshSaveBtn: function() {
			const jNode = $(this.domNode);
			const jChecked = jNode.find(".csi-size-chart-mock-table-container :not(.dijitDisabled).dijitChecked .dijitCheckBoxInput");
			const numChecked = jChecked.length;
			const numSelectionRequired = this.changeProductGroup ? 4 : 3; // Number of radio group selections that user should make to complete the form
			this.saveDisabled = (numChecked < numSelectionRequired) || !xml.isValidURL(this.newIncrement) || (this.changeProductGroup && !xml.isValidURL(this.newProductGroup));
			this._setActionButtonsDisabled(false);
		}

	});
});